<div class="card card-nc" *ngIf="hasEntitlements('SEARCH_CARDHOLDER')">
  <div class="card-heading">
    <div class="card-title search-header">CardHolder Profiles</div>
  </div>
  <div style="padding-top: 30px" class="card-body">
    <form
      class=""
      #cardHolderSearchForm="ngForm"
      [formGroup]="cardholdersSearchForm"
      name="cardholdersSearchForm"
      novalidate
      angular-Validator
    >
      <div class="form-group row">
        <div class="col-md-5">
          <app-dropdown-select-control
            *ngIf="ships"
            (keyup.enter)="onSearchEnter($event)"
            classes="form-control input-sm searhBoxheight"
            elementId="location"
            placeholder="Select ship location."
            [searchTerm]="selectedLocation"
            [source]="ships"
            (valueSelected)="selectLocation($event)"
          >
          </app-dropdown-select-control>
        </div>
        <div class="col-md-6">
          <input
            *ngIf="ships"
            type="text"
            formControlName="firstParameter"
            [ngModel]="firstParameter"
            name="firstParameter"
            id="firstParameter"
            class="form-control input-sm searhBoxheight"
            placeholder="Search name,ssn,card number,strip account,chip account."
          />
          <span
            class="help-block has-error validationMessage"
            *ngIf="
              !cardholdersSearchForm.get('firstParameter').valid &&
              cardholdersSearchForm.get('firstParameter').touched &&
              cardholdersSearchForm.get('firstParameter').errors
            "
          >
            Please enter at least 2 characters
          </span>
        </div>

        <div class="col-md-1">
          <button
            type="submit"
            [disabled]="!cardholdersSearchForm.valid"
            id="searchButton"
            (click)="submit()"
            class="form-group btn btn-nc pull-right"
          >
            SEARCH <i [ngClass]="search_btn_spinner"></i>
          </button>
          <br />
        </div>
      </div>
    </form>
  </div>
</div>
<div [ngSwitch]="subview" *ngIf="hasEntitlements('SEARCH_CARDHOLDER')">
  <div *ngSwitchCase="'spinner'">
    <div class="row">
      <div class="col-md-offset-6">
        <i class="fa fa-spinner fa-spin fa-4x"></i>
      </div>
    </div>
  </div>
  <div *ngSwitchCase="'noSearchParameters'">
    <div class="searchResults">
      <div class="row searchResultsRow">Please enter search criteria.</div>
    </div>
  </div>
  <div *ngSwitchCase="'noResults'">
    <div class="searchResults">
      <div class="row searchResultsRow">No results found.</div>
    </div>
  </div>
  <div *ngSwitchCase="'recentResults'" class="searchResults">
    <app-search-results
      (cardholderSelected)="showCardholder($event)"
      [profileSearchResults]="searchResults"
    ></app-search-results>
  </div>
  <div *ngSwitchCase="'results'" class="searchResults">
    <app-search-results
      (cardholderSelected)="showCardholder($event)"
      [profileSearchResults]="searchResults"
    ></app-search-results>
  </div>
</div>
<div
  class="text-error"
  style="color:RED"
  *ngIf="!hasEntitlements('SEARCH_CARDHOLDER')"
>
  You do not have permission to view this page
</div>
